import { IDimensionProps, Radii } from '@grubhubprod/gh-cookbook-react';

export type PageSectionBorderRadius =
  | keyof Radii
  | (string & Record<never, never>);

export const getPageSectionBorderRadius = (
  isBalanceUiEnabled: boolean,
  isBalanceUiLoading: boolean,
  customBorderRadius?: PageSectionBorderRadius
): PageSectionBorderRadius => {
  if (customBorderRadius) {
    return customBorderRadius;
  }

  if (!isBalanceUiLoading && isBalanceUiEnabled) {
    return '8px';
  }

  return '4px';
};

export const getPageSectionDimension = (
  isBalanceUiEnabled: boolean,
  isBalanceUiLoading: boolean
): IDimensionProps['dimension'] => {
  if (!isBalanceUiLoading && isBalanceUiEnabled) {
    return null;
  }

  return '2';
};
